var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8182 0.524586C11.1623 0.318704 10.4414 0.230469 9.75 0.230469C8.59773 0.230469 7.35682 0.465763 6.5 1.11282C5.64318 0.465763 4.40227 0.230469 3.25 0.230469C2.09773 0.230469 0.856818 0.465763 0 1.11282V9.73047C0 9.87753 0.147727 10.0246 0.295455 10.0246C0.354545 10.0246 0.384091 9.99518 0.443182 9.99518C1.24091 9.61282 2.39318 9.34812 3.25 9.34812C4.40227 9.34812 5.64318 9.58341 6.5 10.2305C7.29773 9.73047 8.74545 9.34812 9.75 9.34812C10.725 9.34812 11.7295 9.52459 12.5568 9.96576C12.6159 9.99517 12.6455 9.99518 12.7045 9.99518C12.8523 9.99518 13 9.84812 13 9.70106V1.11282C12.6455 0.848116 12.2614 0.671645 11.8182 0.524586ZM1.18182 8.46576V1.70106C1.83182 1.49517 2.54091 1.40694 3.25 1.40694C4.04182 1.40694 5.09955 1.64812 5.90909 1.98929V8.754C5.09955 8.41282 4.04182 8.17165 3.25 8.17165C2.54091 8.17165 1.83182 8.25988 1.18182 8.46576ZM11.8182 8.46576C11.1682 8.25988 10.4591 8.17165 9.75 8.17165C8.95818 8.17165 7.90045 8.41282 7.09091 8.754V1.98929C7.90045 1.64223 8.95818 1.40694 9.75 1.40694C10.4591 1.40694 11.1682 1.49517 11.8182 1.70106V8.46576Z",
    fill: "#8C5F34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book_icon.76e5afa11e64b8c65e953ce7de118239.svg";
export { ForwardRef as ReactComponent };